import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { history } from "src/services/history";
import { NotificationService } from "src/helpers/notifications";
import { PATHNAMES } from "src/constants/routes";
import { errorResponsesTrns } from "src/translate/responses";
import { IUserProfileCard, IUser } from "src/@types/users";
import { IClone } from "src/@types/clones";
import { IInquiry } from "src/@types/inquiries";
import { IResponseWithPagination } from "src/@types/api";

export const USERS_SLICE_NAME = "users";
export const ITEMS_PER_PAGE = 10;

export const getUserProfileInfoAsync = createAsyncThunk(
  `${USERS_SLICE_NAME}/fetchUserProfileInfo`,
  async (userId: string, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IUser>(`/user/${userId}/profile/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      history.push(PATHNAMES.NOT_FOUND);

      return rejectWithValue(errorText);
    }
  }
);

export const getUserProfileCardSidebarAsync = createAsyncThunk(
  `${USERS_SLICE_NAME}/fetchUserProfileCard`,
  async (userId: string, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IUserProfileCard>(
        `/user/${userId}/profile_user_card_sitebar/`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      history.push(PATHNAMES.NOT_FOUND);

      return rejectWithValue(errorText);
    }
  }
);

interface UserClonesInquiriesParams {
  userId: string;
  page?: number | string;
  sorting?: string;
}

export const getUserProfileClonesAsync = createAsyncThunk(
  `${USERS_SLICE_NAME}/fetchUserProfileClones`,
  async (
    { userId, sorting, page = 1 }: UserClonesInquiriesParams,
    { rejectWithValue }
  ) => {
    try {
      const querySorting = sorting ? `&ordering=${sorting}` : "";

      const { data } = await instance.get<IResponseWithPagination<IClone>>(
        `/clones/?author_id=${userId}&page=${page}&page_size=${ITEMS_PER_PAGE}${querySorting}`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.default);

      return rejectWithValue(errorText);
    }
  }
);

export const getUserProfileInquiriesAsync = createAsyncThunk(
  `${USERS_SLICE_NAME}/fetchUserProfileInquiries`,
  async (
    { userId, sorting, page = 1 }: UserClonesInquiriesParams,
    { rejectWithValue }
  ) => {
    try {
      const querySorting = sorting ? `&ordering=${sorting}` : "";

      const { data } = await instance.get<IResponseWithPagination<IInquiry>>(
        `/user/${userId}/user_profile_inquiries/?page=${page}&page_size=${ITEMS_PER_PAGE}${querySorting}`
      );

      return data;
    } catch ({ response }) {
      const errorText =
        response?.data?.error || errorResponsesTrns.userProfileInquiries;

      NotificationService.error(errorText || errorResponsesTrns.default);

      return rejectWithValue(errorText);
    }
  }
);
